import {createStore, combineReducers, applyMiddleware } from 'redux';
import { createForms } from 'react-redux-form';
import { Dishes } from './dishes';
import { Comments } from './comments';
//import { Promotions } from './promotions';
import { Leaders } from './leaders';
import { Reviews } from './reviews';
import { Updates } from './updates';
import { Simuls } from './simuls';
import { Combos } from './combos';
import { ComboResults } from './comboResults';
import { Fischerteaches } from './fischerteaches';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { InitialFeedback } from './forms';

export const ConfigureStore = () => {
    const store = createStore(
        combineReducers({
            dishes: Dishes,
            comments: Comments,
            //promotions: Promotions,
            leaders: Leaders,
            reviews: Reviews,
            updates: Updates,
	           simuls: Simuls,
             combos: Combos,
             fischerteaches: Fischerteaches,
             comboResults: ComboResults,
            ...createForms({
                feedback: InitialFeedback
            })
        }),
        applyMiddleware(thunk, logger)
    );

    return store;
}
